import { IComponentOptions } from "angular";
import { MachinesChangeViewController } from "./controller";

export const vsComponentName = "machinesChangeView";

export const MachinesChangeViewComponentOptions: IComponentOptions = {
  controller: MachinesChangeViewController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    model: "<",
    resolve: "=",
  },
};
